import { startCase, lowerCase } from 'lodash';
import { useI18n } from '~Hooks';
import { TranslatedString } from '~Types';

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'READY':
      return '#93c47d';
    case 'ACCEPTED':
      return '#ffe599';
    case 'REFUNDED':
    case 'REJECTED':
      return '#cf2a27';
    default:
      return 'transparent';
  }
};

export const getOrderColor = (status: string) => {
  switch (status) {
    case 'COMPLETED':
      return '#009e0f';
    case 'REFUNDED':
    case 'REJECTED':
      return '#cf2a27';
    default:
      return '#000000';
  }
};

export const ordinalSuffix = (n: number) => {
  const i = n % 10;
  const k = n % 100;

  if (i === 1 && k !== 11) {
    return `${n}st`;
  }
  if (i === 2 && k !== 12) {
    return `${n}nd`;
  }
  if (i === 3 && k !== 13) {
    return `${n}rd`;
  }
  return `${n}th`;
};

export const formatStatus = (
  type: string,
  i18n: (obj: string | TranslatedString | null) => string,
) => {
  switch (type) {
    case 'COMPLETED':
      return i18n('OrderStatus.Completed');
    case 'PENDING':
      return i18n('OrderStatus.Pending');
    case 'FAILED':
      return i18n('OrderStatus.Failed');
    case 'REFUNDED':
      return i18n('OrderStatus.Refunded');
    case 'REJECTED':
      return i18n('OrderStatus.Rejected');
    default:
      return startCase(lowerCase(type));
  }
};

export const formatPaymentStatus = (
  type: string,
  i18n: (obj: string | TranslatedString | null) => string,
) => {
  switch (type) {
    case 'SUCCESS':
      return i18n('PaymentStatus.Success');
    case 'FAILED':
      return i18n('PaymentStatus.Failed');
    case 'PENDING':
      return i18n('PaymentStatus.Pending');
    default:
      return startCase(lowerCase(type));
  }
};
